/**
 * Расшифровка стоимости заказа по элементам — для развёрнутого наряда.
 *
 * Заказ хранит ОДНУ сумму, а не цены своих частей: какая часть приходится на
 * аппарат, а какая на печать модели, в базе не записано. Поэтому элементы
 * расцениваются по текущему прайсу — тем же правилом `priceOf`, по которому
 * цена считалась при оформлении заказа.
 *
 * Сумма по прайсу может не сойтись с суммой заказа: цену заказа поправили
 * руками, прайс с тех пор подняли, элемент удалили из справочника. Тогда
 * разница выносится ОТДЕЛЬНОЙ СТРОКОЙ «Корректировка», а не размазывается по
 * ценам: элементы остаются прайсовыми, итог — настоящим, и ничего не спрятано.
 */
import { jawText } from './item-name.js';
import { priceOf } from './pricing.js';
/** Название строки, в которую уходит разница между прайсом и суммой заказа. */
export const CORRECTION_ITEM_NAME = 'Корректировка';
/** Сумма элементов: количество × цена по каждому. */
export function itemsTotalKop(items) {
    return items.reduce((sum, item) => sum + item.qty * item.priceKop, 0);
}
/**
 * Элементы заказа с ценами по прайсу и, если нужно, строкой корректировки.
 *
 * Челюсть дописывается к ОСНОВНОЙ конструкции — как и в названии работы в
 * счёте: это свойство аппарата, а не печати модели рядом с ним.
 *
 * Элемент, удалённый из справочника, в расшифровку не попадает — назвать его
 * нечем, — но его цена не теряется: она окажется в корректировке.
 */
export function orderBreakdown(order, catalog, pay) {
    const items = [];
    if (order.constructionId) {
        const base = catalog.get(order.constructionId);
        const jaw = jawText(order.jaw);
        const name = base?.name ?? 'Конструкция';
        items.push({
            name: jaw ? `${name} ${jaw}` : name,
            qty: order.constructionQty ?? 1,
            priceKop: priceOf(base, pay),
        });
    }
    for (const extra of order.extras ?? []) {
        const found = catalog.get(extra.id);
        if (!found)
            continue;
        items.push({ name: found.name, qty: extra.qty, priceKop: priceOf(found, pay) });
    }
    const difference = order.costKop - itemsTotalKop(items);
    if (difference !== 0)
        items.push({ name: CORRECTION_ITEM_NAME, qty: 1, priceKop: difference });
    return items;
}
//# sourceMappingURL=order-breakdown.js.map